import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { LaunchDarklyService } from 'src/app/core/services/launchdarkly.service';
import { FEATURE_FLAGS } from 'src/app/shared/launchdarkly.constants';
import { LDFlagValue } from 'launchdarkly-js-client-sdk';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit, OnDestroy {
  @Input() matTooltip: string = '';
  @Input() id: string = '';
  @Input() class: string = '';
  @Input() extraClasses: string = '';
  @Input() type = 'button';
  @Input() disabled = false;
  @Input() ariaLabel: string = '';
  @Input() iconClass: string = '';
  @Input() iconStyle: any;
  @Input() imageSrc: string = '';
  @Input() imageStyle: any;
  @Input() imageAlt: string = '';
  @Output() onClick = new EventEmitter<Event>();
  
  // Feature flag for accessibility
  enableDataTableAccessibility$!: Observable<LDFlagValue>;
  enableDataTableAccessibilityValue: boolean = false;
  private subsink: SubSink = new SubSink();

  constructor(private readonly ldService: LaunchDarklyService) {}

  ngOnInit(): void {
    // Initialize feature flag observable
    this.enableDataTableAccessibility$ = this.ldService.getFlagValue(
      FEATURE_FLAGS.ENABLE_DATA_TABLE_ACCESSIBILITY,
      false
    );
    
    // Subscribe to get synchronous value for logic
    this.subsink.add(
      this.enableDataTableAccessibility$.subscribe((value) => {
        this.enableDataTableAccessibilityValue = !!value;
      })
    );
  }

  get accessibleLabel(): string {
    // Only provide accessible label when feature flag is ON
    if (this.enableDataTableAccessibilityValue) {
      return this.ariaLabel;
    }
    return '';
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }
}
